import CloudEvent from '../../services/api/CloudEvents/CloudEvent';
import { DATA_OBJ_EVENT_TYPES, EVENT_SOURCE } from '../../services/api/CloudEvents/constants';
import { getPositionObject, getSubject } from '../../services/api/CloudEvents/CloudEventsApi';
import { CONTROLS, PAGES, PLACEMENTS, SLOTS, TYPES } from './constants';

export default class HeaderNavToSubscriptionPage extends CloudEvent {
  constructor({
    userId,
    orderId,
    merchantId,
    itemId,
    idSeam,
    sessionId,
    clientX,
    clientY,
  }) {
    const subjectParams = {
      userId, orderId, merchantId, itemId,
    };
    super(
      EVENT_SOURCE,
      TYPES.NAVIGATE_TO_SUBSCRIPTION_PAGE,
      getSubject(subjectParams),
      idSeam,
    );
    const data = {
      sessionID: sessionId,
      uxContext: {
        page: PAGES.MAIN_SCREEN,
        slot: SLOTS.HEADER_ROW,
        placement: PLACEMENTS.HEADER_NAV_BAR,
        control: CONTROLS.SUBSCRIPTIONS_BUTTON,
      },
      position: getPositionObject({ clientX, clientY }),
      eventType: DATA_OBJ_EVENT_TYPES.CLICK,
    };
    this.setData(data);
  }
}
